import { Component, HostListener, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { HomeService } from '../../../../services/home.service';
import { DeliveryService } from '../../../../services/delivery';
import { UserService } from '../../../../services/user';

@Component({
  selector: 'app-employeesherocollectingmobile',
  templateUrl: './employeesherocollectingmobile.component.html',
  styleUrl: './employeesherocollectingmobile.component.scss'
})
export class EmployeesherocollectingmobileComponent implements OnInit {

  months = [
    { value: '1', name_ar: 'يناير', name_en: 'January' },
    { value: '2', name_ar: 'فبراير', name_en: 'February' },
    { value: '3', name_ar: 'مارس', name_en: 'March' },
    { value: '4', name_ar: 'أبريل', name_en: 'April' },
    { value: '5', name_ar: 'مايو', name_en: 'May' },
    { value: '6', name_ar: 'يونيو', name_en: 'June' },
    { value: '7', name_ar: 'يوليو', name_en: 'July' },
    { value: '8', name_ar: 'أغسطس', name_en: 'August' },
    { value: '9', name_ar: 'سبتمبر', name_en: 'September' },
    { value: '10', name_ar: 'أكتوبر', name_en: 'October' },
    { value: '11', name_ar: 'نوفمبر', name_en: 'November' },
    { value: '12', name_ar: 'ديسمبر', name_en: 'December' }
  ];

  selectedMonth: string = '';
  herosd: any = '';
  date: any = '';

  AllHeros: any[] = [];
  collectedFromDH: any[] = [];

  totalCollected: number = 0;
  totalCount: number = 0;

  currentPage: number = 1;
  lastPage: number = 1;

  contentReady: boolean = false;
  loadingMore: boolean = false;
  hasData: boolean = false;

  isAr: boolean = localStorage.getItem('language') === 'ar';

  private isLoading: boolean = false;

  constructor(
    private _homeService: HomeService,
    private _deliveryhero: DeliveryService,
    private _userService: UserService
  ) { }

  ngOnInit(): void {
    this.date = new Date().toISOString().split('T')[0];
    this.getAllUsers();
  }

  getAllUsers(): void {
    this.contentReady = true;

    this._homeService.getAllUsers().subscribe({
      next: (data: any) => {
        this.AllHeros = (data || [])
          .filter((user: any) =>
            ['3', '4', '5', '6', '7'].includes(String(user.type))
          )
          .reverse();

        if (this.AllHeros.length > 0) {
          this.herosd = this.AllHeros[0].id;
          this.resetAndLoad();
        } else {
          this.hasData = true;
        }

        this.contentReady = false;
      },
      error: () => {
        this.contentReady = false;
        this.hasData = true;
      }
    });
  }

  getCollectedFromHero(page: number = 1, append: boolean = false): void {
    if (!this.herosd || this.isLoading) return;

    this.isLoading = true;

    if (append) {
      this.loadingMore = true;
    } else {
      this.contentReady = true;
    }

    this._deliveryhero.getAllSalesCollections({
      user_id: this.herosd,
      date: this.selectedMonth ? '' : this.date,
      month: this.selectedMonth ? this.selectedMonth : ''
    }).subscribe({
      next: (res: any) => {
        const newData = res?.data || [];

        if (append) {
          this.collectedFromDH = [...this.collectedFromDH, ...newData];
        } else {
          this.collectedFromDH = newData;
        }

        this.currentPage = res?.current_page || page;
        this.lastPage = res?.last_page || 1;

        this.totalCount = res?.total || this.collectedFromDH.length;

        this.recalcSummary(res);

        this.hasData = this.collectedFromDH.length === 0;

        this.contentReady = false;
        this.loadingMore = false;
        this.isLoading = false;
      },
      error: () => {
        this.contentReady = false;
        this.loadingMore = false;
        this.isLoading = false;
      }
    });
  }

  recalcSummary(res?: any): void {
    /*
      لو الـ API بيرجع إجمالي كلي زي total_sales استخدمه.
      لو مش بيرجعه، هيحسب إجمالي العناصر اللي اتحملت حاليًا.
    */
    if (res?.total_sales !== undefined) {
      this.totalCollected = Number(res.total_sales || 0);
      return;
    }

    if (res?.totalCollected !== undefined) {
      this.totalCollected = Number(res.totalCollected || 0);
      return;
    }

    this.totalCollected = this.collectedFromDH.reduce(
      (acc, item) => acc + Number(item.sales || 0),
      0
    );
  }

  resetAndLoad(): void {
    this.currentPage = 1;
    this.lastPage = 1;
    this.collectedFromDH = [];
    this.totalCollected = 0;
    this.totalCount = 0;
    this.hasData = false;
    this.getCollectedFromHero(1, false);
  }

  dayChange(): void {
    this.selectedMonth = '';
    this.resetAndLoad();
  }

  getByMonth(): void {
    if (this.selectedMonth) {
      this.date = '';
    } else {
      this.date = new Date().toISOString().split('T')[0];
    }

    this.resetAndLoad();
  }

  filterAllHeros(): void {
    this.resetAndLoad();
  }

  loadMore(): void {
    if (this.isLoading || this.loadingMore || this.contentReady) return;
    if (this.currentPage >= this.lastPage) return;

    this.getCollectedFromHero(this.currentPage + 1, true);
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const scrollPosition =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    const windowHeight = window.innerHeight;
    const pageHeight = document.documentElement.scrollHeight;

    const bottomReached = scrollPosition + windowHeight >= pageHeight - 120;

    if (bottomReached) {
      this.loadMore();
    }
  }

  delete(id: any): void {
    Swal.fire({
      title: this.isAr ? 'متأكد؟؟' : 'Are You Sure?',
      showCancelButton: true,
      confirmButtonText: this.isAr ? 'اه' : 'YES',
      cancelButtonText: this.isAr ? 'لا' : 'No'
    }).then((result) => {
      if (result.isConfirmed) {
        this._deliveryhero.deleteDeliveryCollection(id).subscribe({
          next: () => {
            this.resetAndLoad();
          }
        });
      }
    });
  }

  trackById(index: number, item: any): any {
    return item?.id || index;
  }

}